import {
  CREATEFEEWALLET_SUCCESS,
  CREATEFEEWALLET_FAILED,
  RESET_CREATEFEEWALLET,
  LOADING_CREATEFEEWALLET,
  NETWORK_ERROR_CREATEFEEWALLET,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetCreateFeeWallet = () => {
  return { type: RESET_CREATEFEEWALLET };
};

const createFeeWalletList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_CREATEFEEWALLET });
  await partnerServices
    .post("createFeeWallet", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(createFeeWalletListsuccess(res.data));
          break;
        default:
          dispatch(createFeeWalletListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_CREATEFEEWALLET, payload: err });
    });
};
function createFeeWalletListsuccess(data) {
  return {
    type: CREATEFEEWALLET_SUCCESS,
    payload: data,
  };
}
function createFeeWalletListFailed(data) {
  return {
    type: CREATEFEEWALLET_FAILED,
    payload: data,
  };
}

export { resetCreateFeeWallet, createFeeWalletList };
